import { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';

export const ToastMessage = () => {
  const { notification, clearNotification } = useContext(GlobalContext);

  if (!notification.visible) {
    return null;
  }

  return (
    <div
      className={`toast toast-${notification.type}`}
      role='status'
      aria-live='polite'
    >
      <span>{notification.text}</span>
      <button
        type='button'
        className='toast-close'
        aria-label='Close notification'
        onClick={clearNotification}
      >
        x
      </button>
    </div>
  );
};
